import { Injectable } from "@angular/core";
import {environment} from "../../app/config/environment";
import {MyHttp} from "../../app/core/http";

@Injectable()
export class NotificationService {

  constructor(private http: MyHttp) {}

  subscribeToEmail(){
    return this.http.post(`${environment.API}/notifications/email/subscribe`, JSON.stringify({}))
      .map(res => res.json());
  }

  unsubscribeFromEmail(){
    return this.http.post(`${environment.API}/notifications/email/unsubscribe`, JSON.stringify({}))
      .map(res => res.json());
  }

  getEmailStatus(){
    return this.http.get(`${environment.API}/notifications/email/status`)
      .map(res => res.json());
  }

  subscribeToNewsletter(){
    return this.http.post(`${environment.API}/notifications/newsletter/subscribe`, JSON.stringify({}))
      .map(res => res.json());
  }

  unsubscribeFromNewsletter(){
    return this.http.post(`${environment.API}/notifications/newsletter/unsubscribe`, JSON.stringify({}))
      .map(res => res.json());
  }

  getNewsletterStatus(){
    return this.http.get(`${environment.API}/notifications/newsletter/status`)
      .map(res => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/pages/profile/notification.service.ts